import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Button, Glyphicon } from "react-bootstrap";

class Add extends Component {
  render() {
    const { stores } = this.props;
    return (
      <Button bsStyle="success" {...this.props}>
        <Glyphicon glyph="plus" /> {stores.ui.translate.Add}
      </Button>
    );
  }
}

export default inject("stores")(observer(Add));



// WEBPACK FOOTER //
// ./src/Core/Components/Buttons/Add.js